import { useState, useEffect } from 'react'

import Api from 'services/api'

import { useSessionContext } from 'hooks/SessionContext'

export const defaultDealer = {
  address: '',
  city: '',
  state: '',
  zip: '',
  email: ''
}

const useDealerContactInfo = () => {
  const { session: { dealerId } } = useSessionContext()

  const [dealer, setDealer] = useState(defaultDealer)
  const [isDealerLoaded, setIsDealerLoaded] = useState(false)

  useEffect(() => {
    setDealer(defaultDealer)

    if (!dealerId) return

    Api.Dealers.contactInfo(dealerId)
      .then((res) => {
        setDealer(res)
        setIsDealerLoaded(true)
      })
      .catch(() => {
        setDealer(defaultDealer)
        setIsDealerLoaded(true)
      })
  }, [dealerId])

  return { dealer, isDealerLoaded }
}

export default useDealerContactInfo
